// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__2lmdD","Modal":"Modal_Modal__rWP0v","close":"Modal_close__1c-Gd"};